import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { whatsappLink } from '../config/school';
import MobileActionBar from './MobileActionBar';
import { useSchool } from '../contexts/SchoolContext';
import './Footer.css';

const Footer = () => {
  const { settings } = useSchool();
  const phones = settings.phones;
  const whatsappPhones = phones.filter((phone) => phone.whatsapp);
  // Only profiles the school has actually configured are linked.
  const social = [
    { url: settings.facebook_url, label: 'Facebook', icon: <FaFacebook /> },
    { url: settings.twitter_url, label: 'Twitter', icon: <FaTwitter /> },
    { url: settings.instagram_url, label: 'Instagram', icon: <FaInstagram /> }
  ].filter((s) => s.url);

  return (
    <>
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>KSMS</h3>
            <p>KS Montessori & Secondary School - Nurturing young minds with care, creativity, and excellence in education.</p>
            {social.length > 0 && (
              <div className="social-links">
                {social.map((s) => (
                  <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                    {s.icon}
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/programs">Programs</Link></li>
              <li><Link to="/admissions">Admissions</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/track">Track My Application</Link></li>
              {settings.faqs?.length > 0 && <li><Link to="/faq">FAQ</Link></li>}
              {settings.facilities?.length > 0 && <li><Link to="/facilities">Facilities</Link></li>}
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <FaMapMarkerAlt />
              <span>{settings.school_name}, {settings.address}</span>
            </div>
            <div className="contact-item">
              <FaPhone />
              <span>
                {phones.map((phone, index) => (
                  <React.Fragment key={phone.tel}>
                    {index > 0 && ' | '}
                    <a href={`tel:${phone.tel}`} title="Call us">{phone.display}</a>
                  </React.Fragment>
                ))}
              </span>
            </div>
            <div className="contact-item">
              <FaEnvelope />
              <span>
                {whatsappPhones.map((phone, index) => (
                  <React.Fragment key={phone.tel}>
                    {index > 0 && ' | '}
                    <a
                      href={whatsappLink(phone.tel)}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Message us on WhatsApp"
                    >
                      {index === 0 ? `WhatsApp: ${phone.display}` : phone.display}
                    </a>
                  </React.Fragment>
                ))}
              </span>
            </div>
            {settings.map_url && (
              <div className="contact-item">
                <FaEnvelope />
                <a href={settings.map_url} target="_blank" rel="noopener noreferrer">Google Map</a>
              </div>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} KSMS — KS Montessori & Secondary School.
            <br />
            Empowering bright futures with care, creativity, and excellence.
            <br />
            <span className="dev-credit">
              <span style={{ color: '#ff6600', fontSize: '1.2em', verticalAlign: 'middle' }}>🟠</span>
              <span style={{ marginLeft: 8 }}>Developed by </span>
              <a href="https://sungtra.com" target="_blank" rel="noopener noreferrer" title="Visit Sungtra.com" className="dev-link">Sungtra.com</a>
            </span>
          </p>
        </div>
      </div>
    </footer>
    <MobileActionBar />
    </>
  );
};

export default Footer;
